Shopware.Component.register('riccardo-store-list', () => import('./page/riccardo-store-list'));
Shopware.Component.register('riccardo-store-detail', () => import('./page/riccardo-store-detail'));

Shopware.Module.register('riccardo-store', {
    type: 'plugin',
    name: 'riccardo-store',
    title: 'Filialen',
    description: 'Riccardo Filialfinder',
    color: '#E30613',
    icon: 'regular-map-marker',
    entity: 'riccardo_store',

    routes: {
        list: { component: 'riccardo-store-list', path: 'list' },
        detail: { component: 'riccardo-store-detail', path: 'detail/:id', meta: { parentPath: 'riccardo.store.list' }, props: { default: (route) => ({ storeId: route.params.id }) } },
        create: { component: 'riccardo-store-detail', path: 'create', meta: { parentPath: 'riccardo.store.list' } },
    },

    navigation: [{
        id: 'riccardo-store',
        label: 'Filialen',
        color: '#E30613',
        path: 'riccardo.store.list',
        icon: 'regular-map-marker',
        parent: 'sw-content',
        position: 90,
    }],
});
